/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UsageLanguage {
    English = 'English',
    Spanish = 'Spanish',
    Japanese = 'Japanese',
    Other = 'Other',
}
